import createBusinessRepository from '@/repository/business.ts'
import createDirectBusinessRepository from '@/repository/direct-sign/business.ts'
import createDocumentRepository from '@/repository/document.ts'
import createDirectDocumentRepository from '@/repository/direct-sign/document.ts'
import createFeaturebaseRepository from '@/repository/featurebase.ts'
import createHubspotRepository from '@/repository/hubspot.ts'
import createIdentificationRepository from '@/repository/identification.ts'
import createDirectIdentificationRepository from '@/repository/direct-sign/identification.ts'
import createPaymentRepository from '@/repository/payment.ts'
import createSealRepository from '@/repository/seal.ts'
import createSearchRepository from '@/repository/search.ts'
import createSrRepository from '@/repository/signatureRequest.ts'
import createDirectSrRepository from '@/repository/direct-sign/signatureRequest.ts'
import createSigningRepository from '@/repository/signing.ts'
import createDirectSigningRepository from '@/repository/direct-sign/signing.ts'
import createSsoRepository from '@/repository/sso.ts'
import createTanRepository from '@/repository/tan.ts'
import createDirectTanRepository from '@/repository/direct-sign/tan.ts'
import createUserRepository from '@/repository/user.ts'
import createDirectUserRepository from '@/repository/direct-sign/user.ts'
import createVisualSignatureRepository from '@/repository/visualSignature.ts'
import createDirectVisualSignatureRepository from '@/repository/direct-sign/visualSignature.ts'
import createGroupsRepository from '@/repository/groups.ts'
import createMabRepository from '@/repository/mab.ts'
import createDirectMabRepository from '@/repository/direct-sign/mab.ts'

export default function useLegacyApi() {
  const { $legacyApi } = useNuxtApp()

  return {
    // alphabetically sorted; keep it that way
    businessRepository: createBusinessRepository($legacyApi),
    directBusinessRepository: createDirectBusinessRepository($legacyApi),
    directDocumentRepository: createDirectDocumentRepository($legacyApi),
    directIdentificationRepository: createDirectIdentificationRepository($legacyApi),
    directSigningRepository: createDirectSigningRepository($legacyApi),
    directSrRepository: createDirectSrRepository($legacyApi),
    directTanRepository: createDirectTanRepository($legacyApi),
    directUserRepository: createDirectUserRepository($legacyApi),
    directVisualSignatureRepository: createDirectVisualSignatureRepository($legacyApi),
    documentRepository: createDocumentRepository($legacyApi),
    featurebaseRepository: createFeaturebaseRepository($legacyApi),
    hubspotRepository: createHubspotRepository($fetch),
    identificationRepository: createIdentificationRepository($legacyApi),
    paymentRepository: createPaymentRepository($legacyApi),
    sealRepository: createSealRepository($legacyApi),
    searchRepository: createSearchRepository($legacyApi),
    signingRepository: createSigningRepository($legacyApi),
    srRepository: createSrRepository($legacyApi),
    ssoRepository: createSsoRepository($legacyApi),
    tanRepository: createTanRepository($legacyApi),
    userRepository: createUserRepository($legacyApi),
    visualSignatureRepository: createVisualSignatureRepository($legacyApi),
    groupsRepository: createGroupsRepository($legacyApi),
    mabRepository: createMabRepository($legacyApi),
    directMabRepository: createDirectMabRepository($legacyApi),
  }
}
